import { AbstractControl, ValidationErrors } from '@angular/forms';
import { WORK_EMAILS_REGEX } from '@shared/helpers/utils.helper';

export class PersonalEmailAllowedValidator {
  static PersonalEmailAllowed(AC: AbstractControl): ValidationErrors | null {
    if (AC.value && AC.value.match(WORK_EMAILS_REGEX)) {
      return {
        PersonalEmailAllowed: true
      };
    }

    return null;
  }
}
